import { useCallback, useEffect, useState } from "react";
import useAlert from "../Alerts/useAlert";
import { BusinessUnit } from "../Types/BusinessUnit";
import { typeCheckResponse } from "./TypeUtils";
import { useHttpUtils } from "./useHttpUtils";

export const useBusinessUnits = (includeDeleted: boolean = false) => {
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [businessUnits, setBusinessUnits] = useState<BusinessUnit[]>([]);
    const [loading, setLoading] = useState(true);

    const getBusinessUnits = useCallback(() => {
        setLoading(true);
        fetchDataAuthenticated(`api/v1/businessunit/?includeDeleted=${includeDeleted}`)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error("Failed to get business units");
            })
            .then(data => {
                const expectedType: BusinessUnit[]=[];
                if (!typeCheckResponse(data, expectedType)) {
                    throw new Error("Data was not expected type when fetching business units");
                }
                setBusinessUnits(data.toSorted((a, b) => a.code.localeCompare(b.code)));
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [fetchDataAuthenticated, includeDeleted, setAlert]);

    useEffect(() => {
        getBusinessUnits();
    }, [getBusinessUnits]);

    return { loading, businessUnits, getBusinessUnits };
};